import { View, Text, StyleSheet } from "@react-pdf/renderer";
import React, { Fragment } from "react";

const EmployeeDetailList = ({ data }) => {
  const styles = StyleSheet.create({
    container: {
      width: "100%",
      flexDirection: "row",
      paddingLeft: "15px",
      marginTop: 15,
      marginBottom: 25,
    },
    subContiner: {
      width: "50%",
    },
    dataContainer: {
      width: "100%",
      flexDirection: "row",
    },
    title: {
      width: "40%",
      color: "#00000099",
      opacity: 0.5,
      fontSize: "11px",
      fontWeight: "500",
      marginBottom: "5px",
    },
    list: {
      width: "60%",
      color: "#141414F4",
      fontSize: "11px",
      fontStyle: "bold",
    },
  });
  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.subContiner}>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Employee ID</Text>
            <Text style={styles.list}>
              {data?.pdf_details?.employee_id
                ? data?.pdf_details?.employee_id
                : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Email ID</Text>
            <Text style={styles.list}>
              {data?.employee_email ? data?.employee_email : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Phone No</Text>
            <Text style={styles.list}>
              {data?.employee_phone ? data?.employee_phone : "-"}
            </Text>
          </View>
        </View>
        <View style={styles.subContiner}>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Employee Name</Text>
            <Text style={styles.list}>
              {data?.employee_name ? data?.employee_name : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Submitted to</Text>
            <Text style={styles.list}>
              {data?.submitted_to_email ?? data?.submitted_to ?? "-"}
            </Text>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default EmployeeDetailList;
